export const DATED_RASTER_PANE = 'datedRaster';
export const DATED_RASTER_PANE_Z_INDEX = 340;
